import { useState } from 'react';
import TranslateService from './TranslateService';

function useManageTranslate() {
    const [translates, setTranslates] = useState({})
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const getTranslates = async () => {
        setIsLoading(true);
        try {
            const response = await TranslateService.getTranslates();
            setTranslates(response.data)
            setError(null);
        } catch (err) {
            console.log(err)
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const registerTranslate = async (formData) => {
        let result = true
        setIsLoading(true);
        try {
          console.log(formData)
          await TranslateService.registerTranslate(formData);
          getTranslates()
        } catch (err) {
          result = false
          console.log(err)
          setError(err.response.data.message || 'An error occurred.');
        } finally {
          setIsLoading(false);
        }
        return result
    };

    const updateTranslate = async (formData) => {
        let result = true
        setIsLoading(true);
        try {
            const response = await TranslateService.updateTranslate(formData);
            getTranslates();
        } catch (err) {
            console.log(err)
            setError(err);
            result = false
        } finally {
            setIsLoading(false);
            return result
        }
    };

    const hideTranslate = async (translateId) => {
        let result = true
        setIsLoading(true);
        try {
            await TranslateService.hideTranslate(translateId);
            getTranslates();
        } catch (err) {
            result = false
            setError(err);
            console.log(err)
        } finally {
            setIsLoading(false);
            return result
        }
    };

    return {
        translates,
        isLoading,
        error,
        getTranslates,
        registerTranslate,
        updateTranslate,
        hideTranslate
    };
}

export default useManageTranslate;
